<template>
  <div class="animated fadeInRight ecommerce">
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>查询条件</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="4">
          <el-input v-model="shopAppraiseManageInfo.conditions.prodName" placeholder="商品名称" clearable />
        </el-col>
        <el-col :span="4">
          <el-input v-model="shopAppraiseManageInfo.conditions.appraiseUserName" placeholder="请输入用户" clearable />
        </el-col>
        <el-col :span="4">
          <el-select v-model="shopAppraiseManageInfo.conditions.appraiseScore" placeholder="请选择评分" style="width:100%">
            <el-option v-for="(item, index) in shopAppraiseManageInfo.appraiseScores" :key="index" :label="item.name"
              :value="item.statusCd" />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" icon="el-icon-search" @click="_queryOrdersMethod">查询</el-button>
          <el-button icon="el-icon-refresh" @click="_resetOrdersMethod">重置</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>商品评论</span>
      </div>
      <el-table :data="shopAppraiseManageInfo.appraises" border style="width: 100%">
        <el-table-column prop="prodName" label="商品名称" align="center" />
        <el-table-column prop="appraiseUserName" label="用户" align="center" />
        <el-table-column prop="appraiseScore" label="评分" align="center" />
        <el-table-column prop="context" label="内容" align="center" />
        <el-table-column prop="imgPath" label="图片" align="center" />
        <el-table-column prop="createTime" label="评论时间" align="center" />
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="_ackAppraise(scope.row)">回复</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </el-card>
  </div>
</template>

<script>
import { queryShopAppraise } from '@/api/goods/productDetailApi'
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ShopAppraiseManage',
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      shopAppraiseManageInfo: {
        appraises: [],
        total: 0,
        records: 1,
        appraiseScores: [],
        conditions: {
          prodName: '',
          appraiseScore: '',
          appraiseUserName: '',
          shopId: '',
          objType: '1001',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.shopAppraiseManageInfo.conditions.shopId = getShopId()
    this._listShopAppraises(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    this.getDictData()
  },
  methods: {
    async getDictData() {
      try {
        const { data } = await getDict('s_shop_appraise', 'appraise_score')
        this.shopAppraiseManageInfo.appraiseScores = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listShopAppraises(_page, _rows) {
      this.shopAppraiseManageInfo.conditions.page = _page
      this.shopAppraiseManageInfo.conditions.row = _rows
      const params = {
        ...this.shopAppraiseManageInfo.conditions,
        appraiseUserName: this.shopAppraiseManageInfo.conditions.appraiseUserName.trim(),
        prodName: this.shopAppraiseManageInfo.conditions.prodName.trim(),
        appraiseScore: this.shopAppraiseManageInfo.conditions.appraiseScore.trim()
      }

      try {
        const res = await queryShopAppraise(params)
        this.shopAppraiseManageInfo.total = res.total
        this.shopAppraiseManageInfo.records = res.records
        this.shopAppraiseManageInfo.appraises = res.data
        this.total = res.records
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    _queryOrdersMethod() {
      this._listShopAppraises(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _resetOrdersMethod() {
      this.shopAppraiseManageInfo.conditions.prodName = ''
      this.shopAppraiseManageInfo.conditions.appraiseUserName = ''
      this.shopAppraiseManageInfo.conditions.appraiseScore = ''
      this._listShopAppraises(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    _ackAppraise(appraise) {
      console.log(appraise)
    },
    handleSizeChange(val) {
      this.pageSize = val
      this._listShopAppraises(this.currentPage, val)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listShopAppraises(val, this.pageSize)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>